export default class Rating {

    constructor(element) {
        if(!element) {
            return;
        }

        this.elements = {
            holder: element
        }

        this.elements.fillContainer = this.elements.holder.querySelector('.js-rating-fill-container');
        this.elements.items = this.elements.holder.querySelectorAll('.js-rating-item');
        this.elements.fieldset = this.elements.holder.querySelector('.js-rating-fieldset');

        this.isSet = false;
        this.currentValue = false;

        if(!this.elements.items.length) {return;}

        this._setDOMReferences();
    }

    _setDOMReferences() {
        for (let i = 0; i < this.elements.items.length; i++) {
            const element = this.elements.items[i];
            element.addEventListener("mouseenter", () => this.onEnter(element));
            element.addEventListener("focusin", () => this.onEnter(element));
            element.addEventListener("focusout", () => this.onLeave());
            element.addEventListener("click", () => this.onSelect(i, element));
        }
        this.elements.holder.addEventListener("mouseleave", () => this.onLeave());
    }

    onSelect(index, item) {
        const rating = item.dataset.rating;

        for (let i = 0; i < this.elements.items.length; i++) {
            const element = this.elements.items[i];
            element.classList.remove('is--selected');
        }

        if(this.isSet && rating == this.currentValue) {
            this.isSet = false;
            this.currentValue = false;
        } else {
            this.isSet = true;
            this.currentValue = rating;
            item.classList.add('is--selected');
        }

        if(this.elements.fieldset) {
            const radios = this.elements.fieldset.querySelectorAll('input[type="radio"]');

            if(this.currentValue === false) {
                radios[index].focus();
                radios[index].checked = false;
                radios[index].blur();
            } else if(radios.length) {
                radios[this.currentValue - 1].focus();
                radios[this.currentValue - 1].checked = true;
                radios[this.currentValue - 1].blur();
            }
        }
    }

    onEnter(item) {
        const rating = item.dataset.rating;
        if (this.elements.fillContainer.classList.item(2)) {
            this.elements.fillContainer.classList.replace(this.elements.fillContainer.classList.item(2), 'has--rating-' + rating);
        } else {
            this.elements.fillContainer.classList.add('has--rating-' + rating);
        }
    }

    onLeave() {
        if(this.isSet) {
            this.elements.fillContainer.classList.replace(this.elements.fillContainer.classList.item(2), 'has--rating-' + this.currentValue);
        } else {
            this.elements.fillContainer.classList.remove(this.elements.fillContainer.classList.item(2));
        }
    }

}